import { useState, useEffect } from 'react';

import GET_EXTERNAL_ISSUES from '../../../queries/GET_EXTERNAL_ISSUES';

const useExternalMotives = (client) => {
    const [motives, setMotives] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchMotives = () => {
        setLoading(true);
        return client.query({ query: GET_EXTERNAL_ISSUES, fetchPolicy: 'no-cache' })
            .then(({ data }) => {
                setMotives(data?.getExternalIssues?.payload || []);
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchMotives();
    }, []);

    return { motives, refetchMotives: fetchMotives, loading };
};

export default useExternalMotives;
